import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * SPA page-view tracker for GA4.
 * Fires a `page_view` event on every route change so GA4 sees
 * the full navigation flow, not just the initial landing page.
 */
const GA4RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    const path = location.pathname + location.search;
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default GA4RouteTracker;
